import { CreateClientFollowMappingInput } from 'api';
import { ARRAY, NULL } from 'constants/index';

export const createClientFollowMappingResponse = (values: CreateClientFollowMappingInput) => ({
  createClientFollowMapping: {
    ...values,
    id: '-1',
    required_groups: ARRAY,
    suggested_groups: ARRAY,
    required_users: ARRAY,
    suggested_users: ARRAY,
    follow_conditions: NULL,
    __typename: 'ClientFollowMapping',
  },
});
